module.exports = __webpack_public_path__ + "static/01-weather-data-31cf46213711d22548c069fac6fb7530.png";